import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class TagsService {
  async getAllTags(programId, accountId, page, page_size) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/adminTags/${programId}/view`, MICROSERVICES.PROGRAMMANAGER), {
        params: {
          page_no: page ? page - 1 : null,
          page_size: page_size ? page_size : null,
        }
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitTag(accountId, programId, values, method = 'post', tag) {
    try {
      let param = {}
      if (method === 'put') {
        param = {
          "new_tag": values.name,
          "old_tag": tag.name,
          "update_enrollment": true
        }
      }
      const response = await service[method](Urls.getApiUrl(`admin/${accountId}/adminTags/${programId}${method === 'post' ? `/${values.name}` : ''}`, MICROSERVICES.PROGRAMMANAGER), method === 'put' ? param : '')
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitTagFile(accountId, programId, values, method = 'post', tagFile) {
    try {
      const formData = new FormData()
      formData.append('csv_file', tagFile)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      const response = await service[method](Urls.getApiUrl(`admin/${accountId}/tags/${programId}/${values.name}`, MICROSERVICES.ENROLLMENTMANAGER), formData)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async deleteTag(accountId, programId, tag) {
    try {
      const response = await service.delete(Urls.getApiUrl(`admin/${accountId}/adminTags/${programId}`, MICROSERVICES.PROGRAMMANAGER), { data: tag })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getTagCsv(accountId, programId, tag) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/tags/${programId}/${tag.name}/csv`, MICROSERVICES.ENROLLMENTMANAGER))
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }
}

export const tagsService = new TagsService()